import React from 'react';
import { Headphones, Mic, Loader2, Volume2, X, Hand } from 'lucide-react';
import { useApp } from '../context/AppContext';

export const HandsFreeBar = ({ phase, level, onStop, onInterrupt }) => {
  const { t } = useApp();
  const labels = { listening: t.chat.hfListening, transcribing: t.chat.hfTranscribing, thinking: t.chat.hfThinking, speaking: t.chat.hfSpeaking, idle: t.chat.hfStarting };
  const Icon = phase === 'listening' ? Mic : phase === 'speaking' ? Volume2 : Loader2;
  const scale = 1 + Math.min(level * 6, 0.9);
  return (
    <div className="max-w-3xl mx-auto mb-3 flex items-center gap-3 rounded-2xl border border-primary/40 bg-primary/5 px-4 py-3 animate-fade-in" data-testid="handsfree-bar" data-phase={phase}>
      <span className="relative h-10 w-10 shrink-0 flex items-center justify-center">
        {(phase === 'listening' || phase === 'speaking') && <span className="absolute inset-0 rounded-full bg-primary/20 transition-transform duration-100" style={{ transform: `scale(${scale})` }} />}
        <span className="relative h-9 w-9 rounded-full bg-primary text-primary-foreground flex items-center justify-center"><Icon className={`h-4 w-4 ${phase === 'transcribing' || phase === 'thinking' || phase === 'idle' ? 'animate-spin' : ''}`} /></span>
      </span>
      <div className="min-w-0 flex-1">
        <p className="text-sm font-semibold flex items-center gap-1.5"><Headphones className="h-3.5 w-3.5 text-primary" /> {t.chat.handsFree}</p>
        <p className="text-xs text-muted-foreground truncate" data-testid="handsfree-status">{labels[phase] || phase}</p>
      </div>
      {phase === 'speaking' && (
        <button onClick={onInterrupt} data-testid="handsfree-interrupt-btn" className="h-9 px-3 rounded-lg text-xs font-semibold bg-primary text-primary-foreground hover:bg-primary/90 flex items-center gap-1.5"><Hand className="h-3.5 w-3.5" /> {t.chat.hfInterrupt}</button>
      )}
      <button onClick={onStop} data-testid="handsfree-stop-btn" className="h-9 px-3 rounded-lg text-xs font-semibold bg-background border border-border hover:bg-accent flex items-center gap-1.5"><X className="h-3.5 w-3.5" /> {t.chat.hfStop}</button>
    </div>
  );
};
